/* ───────────────────────────────────────────────────────────────────────────
   promo30-co.js — LA CUENTA ATRÁS DEL -30%, SIN SERVIDOR.

   Qué hace: pinta «⏰ Últimos días con -30% · termina el domingo · quedan Xd Yh Zm»
   en la home y en la ficha de producto NORMAL, y al llegar el corte la QUITA —
   sin recargar la página y sin que nadie tenga que desplegar nada ese domingo a
   medianoche.

   EL CORTE ES FIJO: `2026-09-21T05:00:00Z`. Domingo 20-sep-2026 24:00 hora Colombia
   = lunes 21-sep 00:00 COT. Colombia va en UTC-5 TODO EL AÑO (sin horario de
   verano), así que 00:00 COT es 05:00 UTC sin ninguna cuenta que hacer en vivo:
   el número se escribe una vez y no se mueve con la fecha del visitante.
   El MISMO corte vive, por separado, en `meta-co.js` (`CORTE_30`): ese archivo es
   quien apaga el resto de la comunicación del -30% (la marquesina y la barra de
   meta, código propio — no hay ninguna app que ocultar). Los dos literales tienen
   que coincidir; no se comparten en un módulo porque son dos assets `defer`
   independientes y `<script>` no puede repartir una constante entre ellos sin un
   tercer archivo — el coste de esa unificación es mayor que el de mantener un
   solo string igual en dos sitios, y el barrido de la suite lo vigila.

   🔒 ESTE ARCHIVO SÓLO DECIDE UN `<div>`, NADA MÁS. La versión anterior de este
   comentario hablaba de un apagado GLOBAL con una clase en `<html>` — se descartó:
   las piezas que parecían de una app (marquesina «-30%», tarjeta de envío gratis)
   son código PROPIO (`marquesina-co.liquid` + `meta-co.js`), no de una app de
   terceros, y ya tienen su propio candado por fecha ahí. Duplicar el apagado aquí
   sólo sumaba una segunda fuente de verdad sobre la MISMA hora.

   DÓNDE SE INYECTA Y POR QUÉ AHÍ. `#shopify-section-header .header-wrapper`, al
   final. Ese contenedor es el que mide `cabecera-fija-co.js` para compensar el
   salto cuando la cabecera se compacta: metiendo el reloj DENTRO, viaja gratis con
   la cabecera fija (en la ficha) o queda pegado justo debajo de ella (en la home)
   sin escribir una sola línea de posicionamiento aparte.

   🔒 EL ORDEN DE CARGA IMPORTA, Y HAY DOS REDES. `cabecera-fija-co.js` mide en
   DOMContentLoaded/load; si mide ANTES de que este script meta el reloj, la
   primera medición sale corta y el salto que ese archivo existe para evitar
   vuelve a aparecer un instante. Red 1: este script va ANTES que
   `cabecera-fija-co.js` en layout/theme.liquid (los dos son `defer`, así que
   cargan en ESE orden — la línea exacta queda documentada donde vive
   cabecera-fija-co.js). Red 2, por si el orden cambiara algún día sin que nadie
   se acuerde de esta nota: cada vez que este script AÑADE o QUITA la barra del
   header-wrapper dispara `window.dispatchEvent(new Event('resize'))`, y
   `cabecera-fija-co.js` ya escucha `resize` (con su propio debounce) para
   re-medir. Las actualizaciones de SÓLO TEXTO (el reloj cada 30 s) NO disparan
   resize: la altura de una línea de "2d 14h 32m" no cambia frente a "10d 5h 3m",
   y hacerlo en cada tick sería trabajo sin motivo.

   LA CADENCIA NO ES `setInterval` DE 30000 MS FIJOS, ES UN `setTimeout` QUE SE
   RE-PROGRAMA SOLO. El pedido es "actualizada cada 30 s… recalculando desde el
   corte, nunca acumulando" — y este archivo cumple lo segundo al pie de la letra
   (cada tick relee `corteMs - ahora()`, jamás decrementa un contador propio) pero
   además recorta la espera cuando falta MENOS de 30 s para el corte: así el
   apagado no llega hasta 30 s tarde después de la hora exacta, y de paso es lo
   que permite probar la transición en vivo sin esperar 30 s reales en la suite
   (basta con acercar el reloj de prueba al corte).

   COSTURAS DE PRUEBA. `window.__CO_PROMO30_AHORA` (número, ms epoch): si está
   definida se usa en vez de `Date.now()`, releída en CADA comprobación (no se
   cachea), así que un test puede "avanzar el reloj" reasignándola entre un tick
   y el siguiente. `data-corte` (atributo opcional del propio `<script>`, ISO):
   sustituye al corte fijo del 21-sep — sin él, y en producción, se usa siempre
   el corte real.

   🔒 UN `data-corte` ILEGIBLE NO PUEDE DEJAR EL RELOJ ENCENDIDO PARA SIEMPRE.
   `Date.parse` de un atributo mal escrito da `NaN`, y `ahora() >= NaN` es
   SIEMPRE `false` — o sea que un typo en el atributo apagaría el apagado
   automático entero, el peor de los dos fallos posibles para esta pieza (mejor
   apagar de más que prometer un descuento vencido). Con `NaN` se cae al corte
   real por defecto.

   DEGRADA AL DEFECTO DE SIEMPRE, NUNCA A ALGO ROTO. Sin `document.currentScript`
   (no debería pasar: es un `<script>` normal, no un módulo ni uno insertado por
   JS) la plantilla y el sufijo se leen vacíos → el reloj sencillamente no se
   pinta en ninguna página, pero el corte SIGUE siendo el real: lo único que se
   pierde en ese caso extremo es la cuenta atrás visible.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var CORTE_DEFECTO = '2026-09-21T05:00:00Z';

  // Se captura YA, de forma síncrona: `document.currentScript` deja de valer una
  // vez que este script termina de ejecutarse (y desde luego dentro de un
  // `setTimeout` o de un listener de `DOMContentLoaded`), así que hay que leer
  // sus atributos ahora y guardar sólo los VALORES, no el nodo.
  var propioScript = document.currentScript;
  var corteAttr = propioScript ? propioScript.getAttribute('data-corte') : null;
  var corteMs = Date.parse(corteAttr || CORTE_DEFECTO);
  if (isNaN(corteMs)) corteMs = Date.parse(CORTE_DEFECTO);

  var plantilla = (propioScript && propioScript.getAttribute('data-plantilla')) || '';
  var sufijo = (propioScript && propioScript.getAttribute('data-sufijo')) || '';
  // Home, o ficha de producto que NO sea uno de los 6 del 2x1 (esos usan la
  // plantilla `cod-co` y nunca llevaron reloj: su oferta no es el -30%).
  var aplica = plantilla === 'index' || (plantilla === 'product' && sufijo !== 'cod-co');

  // Sin plantilla aplicable no hay nada que este script tenga que hacer: ni
  // medir, ni programar un tick, ni tocar el DOM. Salir ya es más claro que
  // dejar que `pintarBarra` se auto-descarte en cada llamada.
  if (!aplica) return;

  function ahora() {
    return typeof window.__CO_PROMO30_AHORA === 'number' ? window.__CO_PROMO30_AHORA : Date.now();
  }

  function terminado() {
    return ahora() >= corteMs;
  }

  function textoRestante() {
    var restante = Math.max(0, corteMs - ahora());
    var totalMin = Math.floor(restante / 60000);
    var d = Math.floor(totalMin / 1440);
    var h = Math.floor((totalMin % 1440) / 60);
    var m = totalMin % 60;
    return '⏰ Últimos días con -30% · termina el domingo · quedan ' +
      d + 'd ' + h + 'h ' + m + 'm';
  }

  function headerWrapper() {
    var sec = document.getElementById('shopify-section-header');
    return sec ? sec.querySelector('.header-wrapper') : null;
  }

  var barra = null;
  var temporizador = null;

  function pintarBarra() {
    var cont = headerWrapper();
    if (!cont) return;   // sin el contenedor (aún sin maquetar) no se inventa dónde meterla
    if (!barra) {
      barra = document.createElement('div');
      barra.className = 'co-promo30';
      cont.appendChild(barra);
      window.dispatchEvent(new Event('resize'));
    }
    barra.textContent = textoRestante();
  }

  function quitarBarra() {
    if (!barra) return;
    if (barra.parentNode) barra.parentNode.removeChild(barra);
    barra = null;
    window.dispatchEvent(new Event('resize'));
  }

  function apagar() {
    quitarBarra();
    if (temporizador) { clearTimeout(temporizador); temporizador = null; }
  }

  function programarProximoTick() {
    var restante = corteMs - ahora();   // > 0 siempre que se llega hasta aquí (ver tick/iniciar)
    // Techo de 30 s (la cadencia pedida) y suelo de 250 ms (por si el reloj de
    // prueba ya cruzó el corte por un pelo): cerca de la hora exacta el hueco se
    // recorta solo, así el apagado no llega hasta 30 s tarde.
    var espera = Math.min(30000, Math.max(250, restante + 50));
    temporizador = setTimeout(tick, espera);
  }

  function tick() {
    if (terminado()) { apagar(); return; }
    pintarBarra();
    programarProximoTick();
  }

  function iniciar() {
    if (terminado()) { apagar(); return; }
    pintarBarra();
    programarProximoTick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
